import * as React from 'react';
import { Loader } from '../../../components/Loader/Loader';
import { useEffect } from 'react';
import { parse } from 'query-string';
import { getOrderBySessionId } from '../../../services/public/order';
import { getConfig } from '../../../services/public/config';
import { isDev, isLocal } from '../../../helpers/domain';
import { PAY360_RESULT } from '../../../consts/payment';
import { createBrokenOrder, deleteBrokenOrder, updateBrokenOrder } from '../../../services/public/brokenOrder';

const MobilePaymentSuccessHosted = props => {
  useEffect(() => {
    const { history } = props;
    const search = parse(history.location.search);
    const sessionId = search.sessionId as string;

    let initialTimer = null;
    let maximumTimer = null;
    let timer = null;
    let settled = false;

    const subdomain = document.location.hostname.replace('payment', 'orders');
    const protocol = document.location.protocol;
    const port = document.location.port;
    const clearTimers = () => {
      clearTimeout(initialTimer);
      clearTimeout(maximumTimer);
      clearInterval(timer);
    };
    const finish = (result: string, cleanup: () => Promise<any>) => {
      if (settled) return;
      settled = true;
      clearTimers();
      const redirect = () =>
        window.location.assign(
          isDev(document.location.hostname) || isLocal(document.location.hostname)
            ? `${protocol}//${subdomain}:${port}/mobile/result?result=${result}`
            : `${protocol}//${subdomain}/mobile/result?result=${result}`
        );
      cleanup().then(redirect, redirect);
    };

    createBrokenOrder(sessionId)
      .then(() => getConfig())
      .then(res => {
        const { payments } = res;
        const { pay360 } = payments;
        const { pay360InitialWaitingTime, pay360MaximumWaitingTime, pay360AdditionalWaitingTime } = pay360;

        maximumTimer = setTimeout(() => {
          finish(PAY360_RESULT.TIMEOUT, () => updateBrokenOrder(sessionId));
        }, pay360MaximumWaitingTime);

        initialTimer = setTimeout(() => {
          getOrderBySessionId(sessionId).then(res => {
            const { orderStatus } = res;
            switch (orderStatus) {
              case PAY360_RESULT.PAID:
                finish(PAY360_RESULT.PAID, () => deleteBrokenOrder(sessionId));
                break;
              case PAY360_RESULT.CANCELED:
                finish(PAY360_RESULT.CANCELED, () => deleteBrokenOrder(sessionId));
                break;
              default: {
                timer = setInterval(() => {
                  getOrderBySessionId(sessionId).then(res => {
                    const { orderStatus } = res;
                    switch (orderStatus) {
                      case PAY360_RESULT.PAID:
                        finish(PAY360_RESULT.PAID, () => deleteBrokenOrder(sessionId));
                        break;
                      case PAY360_RESULT.CANCELED:
                        finish(PAY360_RESULT.CANCELED, () => deleteBrokenOrder(sessionId));
                    }
                  });
                }, pay360AdditionalWaitingTime);
              }
            }
          });
        }, pay360InitialWaitingTime);
      });
    return () => {
      settled = true;
      clearTimers();
    };
  }, []);

  return (
    <div className={'mt-3'}>
      <Loader />
      <div className={'text-center'}>Waiting for payment authorization...</div>
    </div>
  );
};

export default MobilePaymentSuccessHosted;
